var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"number px-2",staticStyle:{"font-size":"smaller"},attrs:{"small":"","label":""}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s((_vm.count === null || _vm.count === undefined) ? "" : _vm.count)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }